// 채점·합격가능성의 HACCP 판정 근거 문구(순수 함수·상수).
// components·features 양쪽에서 쓰이므로 레이어 중립인 lib에 둔다.

/**
 * 합격 가능성 판정 근거 문장.
 * 전체 배점 대비 득점률로 높음(≥90%)·보통(70~90%)·낮음(<70%)을 가른다.
 */
export function passLikelihoodBasis(
    total: number,
    max: number,
    likelihood?: string | null
): string {
    const pct = max > 0 ? Math.round((total / max) * 100) : 0
    const label =
        likelihood === 'high'
            ? '높음'
            : likelihood === 'medium'
              ? '보통'
              : likelihood === 'low'
                ? '낮음'
                : '-'
    return (
        `합격 가능성은 전체 배점 대비 득점률로 판정합니다 — 90% 이상 “높음”, ` +
        `70% 이상 “보통”, 70% 미만 “낮음”. 현재 ${total}/${max}점(${pct}%)이라 “${label}”입니다. ` +
        `일부 항목이 미채점(밴딩 실패 등)이면 그만큼 낮게 반영됩니다.`
    )
}

/** 항목 판정·채점 방식의 HACCP 기준 안내(고정 설명). */
export const SCORING_CRITERIA_NOTE =
    '항목 판정은 적합=배점 만점, 미흡=일부 충족(부분 점수), 부적합=0점입니다. ' +
    '선행요건은 평가로직에 따른 규칙 채점, HACCP관리는 배점기준(척도)에 따른 AI 밴딩으로 점수를 매깁니다.'
